export const SET_MAIN_SEARCH_PARAMS = 'SET_MAIN_SEARCH_PARAMS';
export const SET_IS_COUNTING = 'SET_IS_COUNTING';
export const RESET_REQUESTS_DATA = 'RESET_REQUESTS_DATA';
export const SET_STATISTICS_DATA = 'SET_STATISTICS_DATA';
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';
export const SET_DASHBOARD_FILTERED_REQUESTS =
  'SET_DASHBOARD_FILTERED_REQUESTS';
export const SET_DASHBOARD_ITEMS = 'SET_DASHBOARD_ITEMS';